import * as React from 'react'
import { DateTime } from 'luxon'
import authStore from '../../../store/authStore.ts'

/**
 * Displays the current time in the user's configured timezone when it differs
 * from the browser's local timezone. Useful for super users who are logged in
 * as another user in a different timezone.
 */
export const UserTimezoneClock: React.FC = () => {
    const timezone = authStore(s => s.timezone)
    const [now, setNow] = React.useState(DateTime.now())

    // Update every 30 seconds
    React.useEffect(() => {
        const interval = setInterval(() => setNow(DateTime.now()), 30_000)
        return () => clearInterval(interval)
    }, [])

    // Don't show if timezone isn't set or matches local
    if (!timezone?.value || timezone.value === 'na') return null

    const localZone = DateTime.local().zoneName
    if (localZone === timezone.value) return null

    const userTime = now.setZone(timezone.value)
    const timeStr = userTime.toFormat('h:mm a')
    const zoneAbbr = userTime.toFormat('ZZZZ')

    return (
        <div className="flex flex-col items-center text-primary-content text-xs leading-tight opacity-80 ml-2">
            <div className="font-semibold">{timeStr}</div>
            <div className="text-[10px]">{zoneAbbr}</div>
        </div>
    )
}
